import 'vite/modulepreload-polyfill'
;(w => {
  function formatEntryKey(name) {
    // Format the import path; eg: './appFactories/loginApp.js' -> 'LoginApp'
    const base = name.split('/').slice(-1).at(0).split('.').at(0)
    return `${base.at(0).toUpperCase()}${base.slice(1)}`
  }

  async function _loadApp(appName, props) {
    // Resolve the app as a dynamic import
    const app = await appsMap[appName]()

    if (props) {
      app.mount?.(props)
    }

    return app
  }

  const modules = import.meta.glob(['./appFactories/!(*.test).js', './scss/app.scss'])

  const appsMap = {}

  w.pestpac ??= {}

  // Create an entry in appsMap for each module in './appFactories'
  for (const path in modules) {
    const key = formatEntryKey(path)
    appsMap[key] = modules[path]
  }

  // Expose loadApp function on the global window.pestpac object
  w.pestpac.loadApp = _loadApp
})(window)
